import {
  WSCard,
  WSElement,
  WSSectionToolbar
} from "@wingspanhq/fe-component-library";
import { WorkLog, WorkLogStatus } from "@wingspanhq/wingspan-api-sdk";
import React, { useMemo } from "react";
import { StepItem, Steps } from "../../../shared/components/Steps";
import { isStatusDiscarded } from "../utils/workLogPermissions";

type Props = {
  workLog?: WorkLog;
  shimmer?: boolean;
};

export const WorkLogStatusStepperPayerView: React.FC<Props> = props => {
  const steps: StepItem[] = useMemo(() => {
    const status = props.workLog?.status;
    const isApproved = status === WorkLogStatus.APPROVED;
    const isRejected = status === WorkLogStatus.REJECTED;
    const isInReview = status === WorkLogStatus.IN_REVIEW;
    const isDiscarded = isStatusDiscarded(status as string);
    const hasBeenSubmitted =
      isInReview || isApproved || isRejected || isDiscarded;

    let submittedStatus: StepItem["status"] = "Pending";
    if (isRejected || isDiscarded) submittedStatus = "Rejected";
    else if (isInReview || isApproved) submittedStatus = "Complete";

    return [
      {
        title: "In-progress",
        status: hasBeenSubmitted ? "Complete" : "Active"
      },
      {
        title: "Submitted",
        status: submittedStatus
      },
      {
        title: "Approved",
        status: isApproved ? "Complete" : "Pending"
      }
    ];
  }, [props.workLog?.status]);

  return (
    <WSElement>
      <WSSectionToolbar title="Work log steps" />
      <WSCard shimmer={props.shimmer}>
        <Steps steps={steps} />
      </WSCard>
    </WSElement>
  );
};
